webpackJsonp([3],{

/***/ 1217:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1218:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1219:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2432:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2433);


/***/ }),

/***/ 2433:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2434);
__webpack_require__(2435);
__webpack_require__(2436);

__webpack_require__(2437);
__webpack_require__(2438);

__webpack_require__(2439);

__webpack_require__(2440);
__webpack_require__(1217);
__webpack_require__(1218);
__webpack_require__(2441);
__webpack_require__(1219);
__webpack_require__(2442);
__webpack_require__(856);
__webpack_require__(2443);
__webpack_require__(2444);

__webpack_require__(1217);
__webpack_require__(2445);
__webpack_require__(2446);
__webpack_require__(2447);
__webpack_require__(1219);
__webpack_require__(1218);
__webpack_require__(2448);

__webpack_require__(2449);

__webpack_require__(2450);

__webpack_require__(225);

__webpack_require__(60);
__webpack_require__(2451);
__webpack_require__(2452);
__webpack_require__(2453);
__webpack_require__(2454);
__webpack_require__(2457);
__webpack_require__(140);
__webpack_require__(303);
__webpack_require__(439);

__webpack_require__(312);
__webpack_require__(460);

__webpack_require__(2458);

module.exports = {};

/***/ }),

/***/ 2434:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2435:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2436:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2437:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2438:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2439:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2440:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2441:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2442:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2443:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2444:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2445:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2446:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2447:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2448:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2449:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2450:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


$(function () {
	$('.callout a.close').click(function (e) {
		$(e.currentTarget).parents('.callout').remove();
	});
});

/***/ }),

/***/ 2452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//Generated File
//Do not modify by hand, it will get overwritten
//see smapply generate_js_viewnames for what you want
var viewnames = {
  "accounts-become-applicant": "/acc/bcm/",
  "add-profile-picture": "/acc/pp/+/",
  "admin-account": "/admin/acc/",
  "admin-account-delete-request-cancel": "/acc/del/cncl/",
  "admin-activity": "/admin/activity/",
  "admin-activity-datasource": "/admin/activity/datasource/",
  "admin-award-permanently-delete": "/admin/awards/pdel/",
  "admin-awards-add": "/admin/awards/add/",
  "admin-awards-application-detail": "/admin/awards/<pk>/manage/applications/<submission_id>/view/",
  "admin-awards-application-edit-customfields": "/admin/awards/<pk>/manage/applications/<submission_id>/editcustomfields/",
  "admin-awards-application-get-customfields": "/admin/awards/<pk>/manage/applications/<submission_id>/customfields/",
  "admin-awards-application-rename": "/admin/awards/<pk>/manage/rename/<app_id>/",
  "admin-awards-applications": "/admin/awards/<pk>/manage/applications/",
  "admin-awards-applications-archive": "/admin/awards/<pk>/manage/archive/",
  "admin-awards-applications-assigned-columns": "/admin/awards/<award_id>/assigned/columns/",
  "admin-awards-applications-awarded-columns": "/admin/awards/<award_id>/awarded/columns/",
  "admin-awards-applications-columns": "/admin/awards/<award_id>/columns/",
  "admin-awards-applications-datasource": "/admin/awards/<award_id>/datasource/",
  "admin-awards-applications-delete": "/admin/awards/<pk>/manage/delete/",
  "admin-awards-applications-delete-permanent": "/admin/awards/<pk>/manage/delete/permanent/",
  "admin-awards-applications-delete-permanent-single": "/admin/awards/<pk>/manage/delete/permanent/single/",
  "admin-awards-applications-export": "/admin/awards/<pk>/manage/export/",
  "admin-awards-applications-hide": "/admin/awards/<pk>/manage/hide/",
  "admin-awards-applications-hide-decision": "/admin/awards/<pk>/manage/hide-decision/",
  "admin-awards-applications-labels": "/admin/awards/<pk>/manage/labels/update/",
  "admin-awards-applications-labels-checkboxes": "/admin/awards/<pk>/manage/labels/checkboxes/",
  "admin-awards-applications-labels-create": "/admin/awards/<pk>/manage/labels/create/",
  "admin-awards-applications-labels-delete": "/admin/awards/<pk>/manage/labels/delete/",
  "admin-awards-applications-labels-rename": "/admin/awards/<pk>/manage/labels/rename/",
  "admin-awards-applications-lock": "/admin/awards/<pk>/manage/lock/",
  "admin-awards-applications-new": "/admin/awards/<pk>/manage/new/",
  "admin-awards-applications-reopen": "/admin/awards/<pk>/manage/reopen/",
  "admin-awards-applications-restore": "/admin/awards/<pk>/manage/restore/",
  "admin-awards-applications-revert": "/admin/awards/<pk>/manage/revert/",
  "admin-awards-applications-show-decision": "/admin/awards/<pk>/manage/show-decision/",
  "admin-awards-applications-stages": "/admin/awards/<pk>/manage/stages/",
  "admin-awards-applications-status": "/admin/awards/<pk>/manage/status/",
  "admin-awards-applications-status-update": "/admin/awards/<pk>/manage/updatestatus/",
  "admin-awards-applications-submit": "/admin/awards/<pk>/manage/submit/",
  "admin-awards-applications-taskrecord-delete": "/admin/awards/<pk>/manage/applications/taskrecord/delete/<task_record_id>/",
  "admin-awards-applications-taskrecord-edit": "/admin/awards/<pk>/manage/applications/taskrecord/edit/<task_record_id>/",
  "admin-awards-applications-unarchive": "/admin/awards/<pk>/manage/unarchive/",
  "admin-awards-applications-unhide": "/admin/awards/<pk>/manage/unhide/",
  "admin-awards-applications-unlock": "/admin/awards/<pk>/manage/unlock/",
  "admin-awards-applications-update-award": "/admin/awards/<pk>/manage/updateaward/",
  "admin-awards-applications-update-custom": "/admin/awards/<pk>/manage/updatecustom/<submission_id>/<field_id>/",
  "admin-awards-assignments": "/admin/awards/<pk>/manage/assignments/",
  "admin-awards-assignments-clear-assignments": "/admin/awards/<pk>/manage/assignments/clear/assignments/",
  "admin-awards-assignments-clear-reviews": "/admin/awards/<pk>/manage/assignments/clear/reviews/",
  "admin-awards-assignments-details": "/admin/awards/<pk>/manage/assignments/details/",
  "admin-awards-assignments-manual-create": "/admin/awards/<pk>/manage/assignments/<round_id>/manual/create/",
  "admin-awards-assignments-manual-distribution-precalc": "/admin/awards/<pk>/manage/assignments/distribution/manual/precalc/",
  "admin-awards-assignments-manual-grid": "/admin/awards/<pk>/manage/assignments/<round_id>/manual/grid/",
  "admin-awards-assignments-member-assignment-data-export": "/admin/awards/<pk>/manage/assignments/<round_id>/teams/<team_id>/reviewer/<user_id>/export/",
  "admin-awards-assignments-reviewer-assignment-data": "/admin/awards/<pk>/manage/assignments/<round_id>/reviewers/<user_id>/",
  "admin-awards-assignments-reviewer-assignment-data-export": "/admin/awards/<pk>/manage/assignments/<round_id>/reviewers/<user_id>/export/",
  "admin-awards-assignments-reviewer-conflict-add": "/admin/awards/<pk>/manage/assignments/<round_id>/conflicts/<submission_id>/<reviewer_id>/",
  "admin-awards-assignments-reviewer-conflict-view": "/admin/awards/<pk>/manage/assignments/<round_id>/conflicts/<submission_id>/<reviewer_id>/remove/",
  "admin-awards-assignments-reviewer-reopen": "/admin/awards/<pk>/manage/assignments/<reviewer_id>/reopen/",
  "admin-awards-assignments-reviewer-submit": "/admin/awards/<pk>/manage/assignments/<reviewer_id>/submit/",
  "admin-awards-assignments-reviewer-unassign": "/admin/awards/<pk>/manage/assignments/reviewer/<user_id>/unassign/",
  "admin-awards-assignments-reviewers-data": "/admin/awards/<pk>/manage/assignments/<round_id>/reviewers/",
  "admin-awards-assignments-team-assignment-data-export": "/admin/awards/<pk>/manage/assignments/<round_id>/teams/<team_id>/export/",
  "admin-awards-assignments-team-clear-reviews": "/admin/awards/<pk>/manage/assignments/clear/team/reviews/",
  "admin-awards-assignments-team-details": "/admin/awards/<pk>/manage/assignments/team/<team_id>/details/",
  "admin-awards-assignments-team-member-assignment-data": "/admin/awards/<pk>/manage/assignments/<round_id>/teams/<team_id>/reviewer/<user_id>/",
  "admin-awards-assignments-team-unassign": "/admin/awards/<pk>/manage/assignments/team/<team_id>/unassign/",
  "admin-awards-assignments-teams-assignment-data": "/admin/awards/<pk>/manage/assignments/<round_id>/teams/<team_id>/",
  "admin-awards-assignments-teams-data": "/admin/awards/<pk>/manage/assignments/<round_id>/teams/",
  "admin-awards-award-decision": "/admin/awards/<pk>/manage/award/award-decision",
  "admin-awards-award-decision-meta": "/admin/awards/<pk>/manage/award/award-decision-meta",
  "admin-awards-bulk-task-reset": "/admin/awards/<pk>/manage/rst/bulk/",
  "admin-awards-categories-add": "/admin/awards/categories/add/",
  "admin-awards-categories-checkbox-source": "/admin/awards/categories/checkbox-source/",
  "admin-awards-categories-delete": "/admin/awards/categories/delete/",
  "admin-awards-categories-list": "/admin/awards/categories/list/",
  "admin-awards-categories-rename": "/admin/awards/categories/rename/",
  "admin-awards-categories-update-award": "/admin/awards/categories/update-award/",
  "admin-awards-change-collaborator-access": "/admin/awards/<pk>/manage/app/<app_id>/ca/<member_id>/",
  "admin-awards-dashboard": "/admin/awards/<pk>/manage/dashboard/",
  "admin-awards-dashboard-dates": "/admin/awards/<pk>/manage/dashboard/dates/",
  "admin-awards-dashboard-progress": "/admin/awards/<pk>/manage/dashboard/progress/",
  "admin-awards-dashboard-reviews": "/admin/awards/<pk>/manage/dashboard/reviews/",
  "admin-awards-dashboard-stages": "/admin/awards/<pk>/manage/dashboard/stages/",
  "admin-awards-dashboard-stats": "/admin/awards/<pk>/manage/dashboard/stats/",
  "admin-awards-delete": "/admin/awards/delete/",
  "admin-awards-duplicate": "/admin/awards/duplicate/",
  "admin-awards-edit": "/admin/awards/<pk>/",
  "admin-awards-edit-budget-detail": "/admin/awards/<pk>/budget/",
  "admin-awards-eligibility-clear": "/admin/awards/<award_id>/eligibility/clear/",
  "admin-awards-eligibility-criteria": "/admin/awards/<award_id>/eligibility/criteria/",
  "admin-awards-eligibility-list": "/admin/awards/eligibility-list/",
  "admin-awards-eligibility-quiz": "/admin/settings/eligibility/",
  "admin-awards-eligibility-quiz-create": "/admin/settings/eligibility/create/",
  "admin-awards-eligibility-quiz-delete": "/admin/settings/eligibility/delete/",
  "admin-awards-eligibility-quiz-edit": "/admin/settings/eligibility/edit/",
  "admin-awards-eligibility-quiz-request-update": "/admin/settings/eligibility/requestupdate/",
  "admin-awards-eligibility-quiz-unlock-profiles": "/admin/settings/eligibility/unlockprofiles/",
  "admin-awards-export": "/admin/awards/export/",
  "admin-awards-import": "/admin/awards/import/",
  "admin-awards-listing-availability": "/admin/awards/listing-availability/",
  "admin-awards-make-hidden": "/admin/awards/make-hidden/",
  "admin-awards-make-live": "/admin/awards/make-live/",
  "admin-awards-make-offline": "/admin/awards/make-offline/",
  "admin-awards-make-owner": "/admin/awards/<pk>/manage/app/<app_id>/chown/<member_id>/",
  "admin-awards-make-visible": "/admin/awards/make-visible/",
  "admin-awards-manage": "/admin/awards/<pk>/manage/",
  "admin-awards-manage-budget-detail": "/admin/awards/<pk>/manage/budget/",
  "admin-awards-remove-collaborator": "/admin/awards/<pk>/manage/app/rm/<app_id>/col/<member_id>/",
  "admin-awards-remove-team": "/admin/awards/<pk>/manage/app/rm/<app_id>/team/<team_id>/",
  "admin-awards-revert-delete": "/admin/awards/revert/",
  "admin-awards-round-triggers-list": "/admin/awards/<award_id>/automations/list-round-triggers/<round_id>/",
  "admin-awards-task-record-offline-response": "/admin/awards/<pk>/manage/task_records/<task_record_id>/offline_response/",
  "admin-awards-triggers-action-choices": "/admin/awards/<award_id>/automations/action/choices/",
  "admin-awards-triggers-action-form": "/admin/awards/<award_id>/automations/action/<action_type_id>/form/",
  "admin-awards-triggers-activate": "/admin/awards/<award_id>/automations/activate/",
  "admin-awards-triggers-attachment-add": "/admin/awards/<award_id>/automations/attachment/add/",
  "admin-awards-triggers-attachments-get": "/admin/awards/<award_id>/automations/<trigger_id>/action/<action_id>/atts/",
  "admin-awards-triggers-conditions": "/admin/awards/<award_id>/automations/<trigger_id>/edit/conditions/",
  "admin-awards-triggers-conditions-filter-info": "/admin/awards/<award_id>/automations/conditions/filtersinfo/",
  "admin-awards-triggers-deactivate": "/admin/awards/<award_id>/automations/deactivate/",
  "admin-awards-triggers-delete": "/admin/awards/<award_id>/automations/delete/",
  "admin-awards-triggers-delete-template": "/admin/awards/<award_id>/automations/delete-template/<round_id>/",
  "admin-awards-triggers-duplicate": "/admin/awards/<award_id>/automations/duplicate/",
  "admin-awards-triggers-edit": "/admin/awards/<award_id>/automations/<trigger_id>/edit/",
  "admin-awards-triggers-edit-from-round": "/admin/awards/<award_id>/automations/<trigger_id>/edit/<round_id>/",
  "admin-awards-triggers-folders-add": "/admin/awards/<award_id>/automations/folders/add/",
  "admin-awards-triggers-folders-datasource": "/admin/awards/<award_id>/automations/folders/datasource/",
  "admin-awards-triggers-folders-delete": "/admin/awards/<award_id>/automations/folders/delete/",
  "admin-awards-triggers-folders-move": "/admin/awards/<award_id>/automations/folders/move/",
  "admin-awards-triggers-folders-rename": "/admin/awards/<award_id>/automations/folders/rename/",
  "admin-awards-triggers-list": "/admin/awards/<award_id>/automations/",
  "admin-awards-triggers-list-datasource": "/admin/awards/<award_id>/automations/list-datasource/",
  "admin-awards-triggers-log": "/admin/awards/<award_id>/automations/log/",
  "admin-awards-triggers-new": "/admin/awards/<award_id>/automations/new/",
  "admin-awards-triggers-new-from-template": "/admin/awards/<award_id>/automations/new_from_template/<round_id>/<template_id>/",
  "admin-awards-triggers-remove-from-folder": "/admin/awards/<award_id>/automations/remove-from-folder/",
  "admin-awards-workflow": "/admin/awards/<award_id>/workflow/",
  "admin-awards-workflow-new": "/admin/awards/<award_id>/workflow/new/",
  "admin-awards-workflow-rounds": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/",
  "admin-awards-workflow-rounds-add": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/add/",
  "admin-awards-workflow-rounds-indexes": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/indexes/",
  "admin-awards-workflow-rounds-move-rfg": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/mv/rfg/",
  "admin-awards-workflow-rounds-move-rtg": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/mv/rtg/",
  "admin-awards-workflow-rounds-round": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/",
  "admin-awards-workflow-rounds-round-assignment-rule-activate": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/custom/<rule_id>/act/",
  "admin-awards-workflow-rounds-round-assignment-rule-delete": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/custom/<rule_id>/d/",
  "admin-awards-workflow-rounds-round-assignment-rules": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/custom/",
  "admin-awards-workflow-rounds-round-assignment-rules-edit": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/custom/<rule_id>/",
  "admin-awards-workflow-rounds-round-assignments": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/",
  "admin-awards-workflow-rounds-round-assignments-list": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/list/",
  "admin-awards-workflow-rounds-round-assignments-order": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/order/",
  "admin-awards-workflow-rounds-round-assignments-remaining": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/rem/",
  "admin-awards-workflow-rounds-round-assignments-removeteams": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/removeteams/",
  "admin-awards-workflow-rounds-round-assignments-rules-list": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/custom/list/",
  "admin-awards-workflow-rounds-round-assignments-rules-rem": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/custom/rem/",
  "admin-awards-workflow-rounds-round-assignments-settings": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/assignments/settings/",
  "admin-awards-workflow-rounds-round-delete": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/delete/",
  "admin-awards-workflow-rounds-round-duplicate": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/duplicate/",
  "admin-awards-workflow-rounds-round-evaluation": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/evaluation/",
  "admin-awards-workflow-rounds-round-messages": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/messages/",
  "admin-awards-workflow-rounds-round-rename": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/rename/",
  "admin-awards-workflow-rounds-round-reviewer-configure": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/configure/",
  "admin-awards-workflow-rounds-round-reviewer-form-remove": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/remove/",
  "admin-awards-workflow-rounds-round-settings": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/settings/",
  "admin-awards-workflow-rounds-round-visibility": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/<round_id>/visibility/",
  "admin-awards-workflow-rounds-task-list": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/",
  "admin-awards-workflow-rounds-task-list-edit": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/edit/",
  "admin-awards-workflow-rounds-task-list-indexes": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/indexes/",
  "admin-awards-workflow-rounds-task-list-task-add": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/edit/task/add/<task_type>/",
  "admin-awards-workflow-rounds-task-list-task-convert": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/edit/task/<task_id>/convert/",
  "admin-awards-workflow-rounds-task-list-task-delete": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/task/<task_id>/delete/",
  "admin-awards-workflow-rounds-task-list-task-duplicate": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/task/<task_id>/duplicate/",
  "admin-awards-workflow-rounds-task-list-task-edit": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/edit/task/<task_id>/",
  "admin-awards-workflow-rounds-task-list-task-instance-global": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/task/<task_id>/instanceglobal/",
  "admin-awards-workflow-rounds-task-list-task-move": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/task/<task_id>/move/<new_round_id>/",
  "admin-awards-workflow-rounds-task-list-task-reuse": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/task/<task_id>/reuse/",
  "admin-awards-workflow-rounds-task-list-task-save": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/edit/task/save/",
  "admin-awards-workflow-rounds-task-selector-list": "/admin/awards/<award_id>/workflow/<workflow_id>/rounds/tasks/<round_id>/taskslist/",
  "admin-dashboard-unlock": "/admin/dashboard/unlock/",
  "admin-deepthought-get-latest-download": "/admin/reports/deepthought/get-latest-download/",
  "admin-deepthought-site-crosstab": "/admin/reports/deepthought/crosstab/",
  "admin-deepthought-site-download": "/admin/reports/deepthought/export/",
  "admin-deepthought-site-filter-query": "/admin/reports/deepthought/variables/<variable>/",
  "admin-deepthought-site-query": "/admin/reports/deepthought/query/",
  "admin-deepthought-site-query-download": "/admin/reports/deepthought/query/download/",
  "admin-deepthought-site-schema": "/admin/reports/deepthought/schema/",
  "admin-financial-management-award-status-add": "/admin/financial-management/award-statuses/add/",
  "admin-financial-management-award-status-delete": "/admin/financial-management/award-statuses/<status_id>/delete/",
  "admin-financial-management-award-status-rename": "/admin/financial-management/award-statuses/<status_id>/rename/",
  "admin-financial-management-fund-balance": "/admin/financial-management/funds/<fund_id>/balance/",
  "admin-financial-management-fund-bulk-deposit": "/admin/financial-management/funds/deposit/",
  "admin-financial-management-fund-bulk-withdrawal": "/admin/financial-management/funds/withdrawal/",
  "admin-financial-management-fund-deposit": "/admin/financial-management/funds/<fund_id>/deposit/",
  "admin-financial-management-fund-detail": "/admin/financial-management/funds/<fund_id>/detail/",
  "admin-financial-management-fund-stats": "/admin/financial-management/funds/<fund_id>/stats/",
  "admin-financial-management-fund-transfer": "/admin/financial-management/funds/<fund_id>/transfer/",
  "admin-financial-management-fund-transfer-datasource": "/admin/financial-management/funds/transfer/datasource/",
  "admin-financial-management-fund-withdrawal": "/admin/financial-management/funds/<fund_id>/withdrawal/",
  "admin-financial-management-funds": "/admin/financial-management/funds/",
  "admin-financial-management-funds-active-columns": "/admin/financial-management/funds/columns/active/",
  "admin-financial-management-funds-archive": "/admin/financial-management/funds/archive/",
  "admin-financial-management-funds-archived-columns": "/admin/financial-management/funds/columns/archived/",
  "admin-financial-management-funds-create": "/admin/financial-management/funds/create/",
  "admin-financial-management-funds-delete": "/admin/financial-management/funds/delete/",
  "admin-financial-management-funds-edit-fund-folder": "/admin/financial-management/funds/<fund_id>/move-folder/",
  "admin-financial-management-funds-export": "/admin/financial-management/funds/export/",
  "admin-financial-management-funds-folder-delete": "/admin/financial-management/funds/folders/<folder_id>/delete/",
  "admin-financial-management-funds-folder-rename": "/admin/financial-management/funds/folders/<folder_id>/rename/",
  "admin-financial-management-funds-folders-add": "/admin/financial-management/funds/folders/add/",
  "admin-financial-management-funds-folders-datasource": "/admin/financial-management/funds/folders/datasource/",
  "admin-financial-management-funds-import": "/admin/financial-management/funds/import/",
  "admin-financial-management-funds-move-folder": "/admin/financial-management/funds/move-folder/",
  "admin-financial-management-funds-restore": "/admin/financial-management/funds/restore/",
  "admin-financial-management-funds-trash": "/admin/financial-management/funds/trash/",
  "admin-financial-management-funds-trashed-columns": "/admin/financial-management/funds/columns/trashed/",
  "admin-financial-management-program-balances-update": "/admin/financial-management/program-budgets/update-balances/",
  "admin-financial-management-program-balances-update-template": "/admin/financial-management/program-budgets/update-balances/template/",
  "admin-financial-management-program-budget-balance": "/admin/financial-management/program-budgets/<budget_id>/balance/",
  "admin-financial-management-program-budget-bulk-deposit": "/admin/financial-management/program-budgets/deposit/",
  "admin-financial-management-program-budget-bulk-withdrawal": "/admin/financial-management/program-budgets/withdrawal/",
  "admin-financial-management-program-budget-deposit": "/admin/financial-management/program-budgets/<budget_id>/deposit/",
  "admin-financial-management-program-budget-export": "/admin/financial-management/program-budgets/export/",
  "admin-financial-management-program-budget-stats": "/admin/financial-management/program-budgets/<budget_id>/stats/",
  "admin-financial-management-program-budget-transfer": "/admin/financial-management/program-budgets/<budget_id>/transfer/",
  "admin-financial-management-program-budget-transfer-datasource": "/admin/financial-management/program-budgets/transfer/datasource/",
  "admin-financial-management-program-budget-withdrawal": "/admin/financial-management/program-budgets/<budget_id>/withdrawal/",
  "admin-financial-management-program-budgets": "/admin/financial-management/program-budgets/",
  "admin-financial-management-program-budgets-columns": "/admin/financial-management/program-budgets/columns/",
  "admin-financial-management-transaction-edit": "/admin/financial-management/transactions/<transaction_id>/edit/",
  "admin-financial-management-transactions": "/admin/financial-management/transactions/",
  "admin-global-task-edit": "/admin/reusabletask/edit/",
  "admin-global-task-form-edit": "/admin/reusable/form/<task_id>/",
  "admin-is-guidestar-form": "/admin/awards/is_guidestar_form/<form_id>/",
  "admin-organizations-activate": "/admin/users/org/activate/",
  "admin-organizations-add": "/admin/users/org/add/",
  "admin-organizations-application-detail-panel": "/admin/users/org/<pk>/panel/app/",
  "admin-organizations-deactivate": "/admin/users/org/deactivate/",
  "admin-organizations-detail": "/admin/users/org/<pk>/",
  "admin-organizations-detail-panel": "/admin/users/org/<pk>/panel/",
  "admin-organizations-edit-customfields": "/admin/users/org/<pk>/editcustomfields/",
  "admin-organizations-eligibility-rendered": "/admin/users/org/<pk>/eligibility/rendered/",
  "admin-organizations-export": "/admin/users/org/export/",
  "admin-organizations-get-customfields": "/admin/users/org/<pk>/customfields/",
  "admin-organizations-import": "/admin/users/org/import/",
  "admin-organizations-invite": "/admin/users/org/invite/",
  "admin-organizations-remove": "/admin/users/org/remove/",
  "admin-permissions": "/admin/permissions/",
  "admin-permissions-admins-add": "/admin/permissions/admins/add/",
  "admin-permissions-admins-datasource": "/admin/permissions/admins/datasource/",
  "admin-permissions-admins-delete": "/admin/permissions/admins/delete/",
  "admin-permissions-admins-edit-permissions": "/admin/permissions/admins/edit/permissions/",
  "admin-permissions-admins-edit-programaccess": "/admin/permissions/admins/edit/programaccess/",
  "admin-permissions-admins-invite": "/admin/permissions/admins/invite/",
  "admin-permissions-admins-primary": "/admin/permissions/admins/primary/<pk>/",
  "admin-permissions-delete": "/admin/permissions/delete/<pk>/",
  "admin-permissions-duplicate": "/admin/permissions/duplicate/<pk>/",
  "admin-permissions-edit": "/admin/permissions/edit/<pk>/",
  "admin-permissions-rename": "/admin/permissions/rename/<pk>/",
  "admin-permissions-roles-add": "/admin/permissions/roles/add/",
  "admin-reports-create": "/admin/reports/create/",
  "admin-reports-delete": "/admin/reports/delete/",
  "admin-reports-duplicate": "/admin/reports/duplicate/",
  "admin-reports-edit": "/admin/reports/edit/<pk>/",
  "admin-reports-new": "/admin/reports/edit/",
  "admin-reports-recover": "/admin/reports/recover/",
  "admin-reports-rename": "/admin/reports/rename/<report_id>/",
  "admin-reports-trash": "/admin/reports/trash/",
  "admin-reports-update": "/admin/reports/report-detail/<pk>/",
  "admin-reports-view": "/admin/reports/view/<pk>/",
  "admin-search": "/admin/search/",
  "admin-settings-clear-eligibility-cache": "/admin/settings/clear_eligibility_cache/",
  "admin-settings-customfields": "/admin/settings/metadata/",
  "admin-settings-customfields-remove": "/admin/settings/metadata/remove/<pk>/",
  "admin-settings-dataimport": "/admin/settings/data_import_status/",
  "admin-settings-dataimport-award-status": "/admin/settings/data_import_status/<award_id>/",
  "admin-settings-dataimport-delete": "/admin/settings/data_import_delete/",
  "admin-settings-dataimport-import": "/admin/settings/data_import_import/<award_id>/",
  "admin-settings-dataimport-template": "/admin/settings/data_import_template/<award_id>/",
  "admin-settings-dataimport-upload": "/admin/settings/data_import_upload/",
  "admin-settings-dataimport-validate": "/admin/settings/data_import_validate/<award_id>/",
  "admin-settings-emails": "/admin/emails/",
  "admin-settings-emails-attachments": "/admin/emails/attachments/edit/",
  "admin-settings-emails-create": "/admin/emails/create/",
  "admin-settings-emails-domains-validate": "/admin/emails/domains/validate/",
  "admin-settings-emails-domains-validate-inline": "/admin/emails/domains/validate-inline/",
  "admin-settings-emails-logs": "/admin/emails/logs/",
  "admin-settings-emails-organization-create": "/admin/emails/org/create/",
  "admin-settings-emails-scheduled-delete": "/admin/emails/logs/schd/<pk>/d/",
  "admin-settings-emails-sender-default": "/admin/emails/sender/default/",
  "admin-settings-emails-sender-edit": "/admin/emails/sender/edit/",
  "admin-settings-emails-sender-list": "/admin/emails/sender/list/",
  "admin-settings-emails-submission-create": "/admin/emails/sub/create/",
  "admin-settings-emails-template-edit": "/admin/emails/templates/edit/",
  "admin-settings-emails-template-list": "/admin/emails/templates/list/",
  "admin-settings-files": "/admin/settings/files/",
  "admin-settings-files-delete": "/admin/settings/files/delete/",
  "admin-settings-files-detail": "/admin/settings/files/detail/<id>/",
  "admin-settings-files-upload": "/admin/settings/files/upload/",
  "admin-settings-general": "/admin/settings/general/",
  "admin-settings-generate-template": "/admin/settings/generate_template/",
  "admin-settings-global-tasks": "/admin/settings/reusabletasks/",
  "admin-settings-global-tasks-add-to-stages": "/admin/settings/reusabletasks/addtostages/",
  "admin-settings-global-tasks-datasource": "/admin/settings/reusabletasks/datasource/",
  "admin-settings-global-tasks-delete": "/admin/settings/reusabletasks/delete/",
  "admin-settings-global-tasks-duplicate": "/admin/settings/reusabletasks/duplicate/",
  "admin-settings-guidestar-enabled": "/admin/settings/integrations/guidestar/enable/",
  "admin-settings-guidestar-mappings": "/admin/settings/integrations/guidestar/mappings/",
  "admin-settings-guidestar-mappings-datasource": "/admin/settings/integrations/guidestar/mappings/datasource",
  "admin-settings-integrations": "/admin/settings/integrations/",
  "admin-settings-integrations-salesforce-action-activate": "/admin/settings/integrations/salesforce/<integration_id>/activate/<action_id>/",
  "admin-settings-integrations-salesforce-action-deactivate": "/admin/settings/integrations/salesforce/<integration_id>/deactivate/<action_id>/",
  "admin-settings-integrations-salesforce-action-pull": "/admin/settings/integrations/salesforce/<integration_id>/pull/<action_id>/",
  "admin-settings-integrations-salesforce-action-push": "/admin/settings/integrations/salesforce/<integration_id>/push/<action_id>/",
  "admin-settings-integrations-salesforce-bulk-action": "/admin/settings/integrations/salesforce/<integration_id>/bulk/",
  "admin-settings-integrations-salesforce-bulk-delete": "/admin/settings/integrations/salesforce/bulk_delete/",
  "admin-settings-integrations-salesforce-detail": "/admin/settings/integrations/salesforce/<integration_id>/",
  "admin-settings-integrations-salesforce-rename": "/admin/settings/integrations/salesforce/<integration_id>/rename/",
  "admin-settings-integrations-sync-log": "/admin/settings/integrations/sync/log/",
  "admin-settings-notifications": "/admin/settings/notifications/",
  "admin-settings-notifications-edit": "/admin/settings/notifications/edit/<name>/",
  "admin-settings-notifications-reset": "/admin/settings/notifications/reset/<name>/",
  "admin-settings-notifications-test-email": "/admin/settings/notifications/test_email/<name>/",
  "admin-settings-pages": "/admin/settings/pages/",
  "admin-settings-pages-applicant-dashboard": "/admin/settings/pages/a/dash/",
  "admin-settings-pages-applicant-opportunities": "/admin/settings/pages/a/opp/",
  "admin-settings-pages-create": "/admin/settings/pages/+/",
  "admin-settings-pages-list": "/admin/settings/pages/list/",
  "admin-settings-pages-preview": "/admin/settings/pages/preview/",
  "admin-settings-pages-reviewer-dashboard": "/admin/settings/pages/r/dash/",
  "admin-settings-privacy-upload": "/admin/settings/privacy_upload/",
  "admin-settings-registration": "/admin/settings/registration/",
  "admin-settings-superuser": "/admin/settings/superuser/",
  "admin-settings-translations-datasource": "/admin/settings/translations/datasource/",
  "admin-settings-translations-default": "/admin/settings/translations/default/",
  "admin-settings-translations-download": "/admin/settings/translations/download/<stringchoice>/",
  "admin-settings-translations-index": "/admin/settings/translations/",
  "admin-settings-translations-upload": "/admin/settings/translations/upload/",
  "admin-settings-translations-visibility": "/admin/settings/translations/visibility/",
  "admin-teams": "/admin/users/teams/",
  "admin-teams-add-users": "/admin/users/teams/add-users/",
  "admin-teams-create": "/admin/users/teams/create/",
  "admin-teams-delete": "/admin/users/teams/delete/<pk>/",
  "admin-teams-edit": "/admin/users/teams/edit/<pk>/",
  "admin-teams-remove-user": "/admin/users/teams/remove-user/<pk>/",
  "admin-teams-remove-users": "/admin/users/teams/remove-users/<pk>/",
  "admin-user-download-privacy": "/admin/users/<pk>/privacy_request/",
  "admin-users-activate": "/admin/users/activate/",
  "admin-users-add": "/admin/users/add/",
  "admin-users-add-reviewer": "/admin/users/add/r/",
  "admin-users-application-detail-panel": "/admin/users/<pk>/panel/app/",
  "admin-users-assume": "/admin/users/<pk>/assume/",
  "admin-users-columns": "/admin/users/users/columns/",
  "admin-users-columns-applicant": "/admin/users/applicant/columns/",
  "admin-users-columns-organization": "/admin/users/organization/columns/",
  "admin-users-columns-recommender": "/admin/users/recommender/columns/",
  "admin-users-columns-reviewer": "/admin/users/reviewer/columns/",
  "admin-users-datasource": "/admin/users/datasource/",
  "admin-users-deactivate": "/admin/users/deactivate/",
  "admin-users-delete": "/admin/users/delete/",
  "admin-users-detail": "/admin/users/<pk>/",
  "admin-users-detail-panel": "/admin/users/<pk>/panel",
  "admin-users-edit-customfields": "/admin/users/<pk>/editcustomfields/",
  "admin-users-eligibility-rendered": "/admin/users/<pk>/eligibility/rendered/",
  "admin-users-export": "/admin/users/export/",
  "admin-users-get-customfields": "/admin/users/<pk>/customfields/",
  "admin-users-import": "/admin/users/import/",
  "admin-users-invite": "/admin/users/invite/",
  "admin-users-password-reset": "/admin/users/password/reset/",
  "admin-users-reviewer-conflicts-add": "/admin/users/reviewer/<reviewer_id>/conflicts/add/",
  "admin-users-reviewer-conflicts-delete": "/admin/users/reviewer/conflicts/<conflict_id>/rm/",
  "admin-users-reviewer-conflicts-list": "/admin/users/reviewer/<reviewer_id>/conflicts/list/",
  "admin-users-role-add": "/admin/users/role/add/",
  "admin-users-role-change": "/admin/users/role/change/",
  "admin-users-role-remove": "/admin/users/role/remove/",
  "api-smapply-activities": "/api/activity/",
  "api-smapply-activity": "/api/activity/<id>/",
  "api-smapply-apilog": "/api/log/",
  "api-smapply-application": "/api/applications/<id>/",
  "api-smapply-application-file": "/api/applications/<application_id>/tasks/<id>/files/<file_id>/",
  "api-smapply-application-file-creation": "/api/applications/<application_id>/tasks/<id>/files/",
  "api-smapply-application-note": "/api/applications/<application_id>/notes/<id>/",
  "api-smapply-application-notes": "/api/applications/<application_id>/notes/",
  "api-smapply-application-task": "/api/applications/<application_id>/tasks/<id>/",
  "api-smapply-application-tasks": "/api/applications/<application_id>/tasks/",
  "api-smapply-applications": "/api/applications/",
  "api-smapply-applicationtable": "/api/programs/<id>/applications/",
  "api-smapply-applicationtable-detail": "/api/programs/<award_id>/applications/<id>/",
  "api-smapply-assignments": "/api/assignments/",
  "api-smapply-budget": "/api/budgets/<id>/",
  "api-smapply-budgets": "/api/budgets/",
  "api-smapply-bulk-actions": "/api/bulk/",
  "api-smapply-customfield": "/api/customfields/<id>/",
  "api-smapply-customfields": "/api/customfields/",
  "api-smapply-dataexports": "/api/dataexports/",
  "api-smapply-decision": "/api/awards/<id>/",
  "api-smapply-decisions": "/api/awards/",
  "api-smapply-drs": "/api/user_drs/",
  "api-smapply-financial-transaction": "/api/financial-transactions/<id>/",
  "api-smapply-financial-transactions": "/api/financial-transactions/",
  "api-smapply-fund": "/api/funds/<id>/",
  "api-smapply-fund-awards": "/api/funds/<fund_id>/awards/",
  "api-smapply-fund-transactions": "/api/funds/<fund_id>/transactions/",
  "api-smapply-funds": "/api/funds/",
  "api-smapply-oauth2-provider:authorize": "/api/o/authorize/",
  "api-smapply-oauth2-provider:authorized-token-delete": "/api/o/authorized_tokens/<pk>/delete/",
  "api-smapply-oauth2-provider:authorized-token-list": "/api/o/authorized_tokens/",
  "api-smapply-oauth2-provider:delete": "/api/o/applications/<pk>/delete/",
  "api-smapply-oauth2-provider:detail": "/api/o/applications/<pk>/",
  "api-smapply-oauth2-provider:introspect": "/api/o/introspect/",
  "api-smapply-oauth2-provider:list": "/api/o/applications/",
  "api-smapply-oauth2-provider:register": "/api/o/applications/register/",
  "api-smapply-oauth2-provider:revoke-token": "/api/o/revoke_token/",
  "api-smapply-oauth2-provider:token": "/api/o/token/",
  "api-smapply-oauth2-provider:update": "/api/o/applications/<pk>/update/",
  "api-smapply-organization": "/api/organizations/<id>/",
  "api-smapply-organization-eligibility": "/api/organizations/<id>/eligibility/",
  "api-smapply-organization-member": "/api/organizations/<organization_id>/members/<id>/",
  "api-smapply-organization-members": "/api/organizations/<organization_id>/members/",
  "api-smapply-organization-team": "/api/organizations/<organization_id>/teams/<id>/",
  "api-smapply-organization-team-member": "/api/organizations/<organization_id>/teams/<team_id>/members/<id>/",
  "api-smapply-organization-team-members": "/api/organizations/<organization_id>/teams/<team_id>/members/",
  "api-smapply-organization-teams": "/api/organizations/<organization_id>/teams/",
  "api-smapply-organizations": "/api/organizations/",
  "api-smapply-payment": "/api/payments/<id>/",
  "api-smapply-payments": "/api/payments/",
  "api-smapply-program": "/api/programs/<id>/",
  "api-smapply-program-budgets": "/api/program-budgets/",
  "api-smapply-program-budgets-transactions": "/api/program-budgets/<award_id>/transactions/",
  "api-smapply-programs": "/api/programs/",
  "api-smapply-review": "/api/reviews/<id>/",
  "api-smapply-reviews": "/api/reviews/",
  "api-smapply-sis-import": "/api/uis/import/",
  "api-smapply-sis-import-mapped": "/api/uis/import/<id>/",
  "api-smapply-sis-job": "/api/uis/job/<job_id>/",
  "api-smapply-site": "/api/site/",
  "api-smapply-stage": "/api/stages/<id>/",
  "api-smapply-stages": "/api/stages/",
  "api-smapply-task": "/api/tasks/<id>/",
  "api-smapply-tasks": "/api/tasks/",
  "api-smapply-team": "/api/teams/<id>/",
  "api-smapply-team-member": "/api/teams/<team_id>/members/<id>/",
  "api-smapply-team-members": "/api/teams/<team_id>/members/",
  "api-smapply-teamassignments": "/api/teamassignments/",
  "api-smapply-teams": "/api/teams/",
  "api-smapply-user": "/api/users/<id>/",
  "api-smapply-user-eligibility": "/api/users/<id>/eligibility/",
  "api-smapply-users": "/api/users/",
  "applicant-account": "/acc/app/",
  "applicant-eligibility-edit": "/prog/eligibility/edit/",
  "application-completion-message": "/sub/<app_id>/cmp/round_id=<round_id>",
  "application-dashboard": "/prog/",
  "application-delete": "/sub/<app_id>/rmv/",
  "application-detail": "/sub/<app_id>/",
  "application-instructions": "/sub/<app_id>/inst/",
  "application-list-datasource": "/prog/app/ds/",
  "application-notes": "/a/<submission_id>/nts/",
  "application-rename": "/sub/<app_id>/ren",
  "application-save": "/sub/<app_id>/sv/",
  "application-submit-preview": "/sub/<app_id>/sprv/",
  "application-withdraw": "/sub/<app_id>/wd/",
  "cancel-email-change": "/acc/em/c/",
  "change-collaborator-access": "/sub/<app_id>/col/<member_id>/c/",
  "change-user-password": "/acc/cp/",
  "clear-application-needs-attention": "/sub/<app_id>/clear-needs-attention/",
  "delete-collaborator": "/sub/<app_id>/dc/",
  "disconnect-social-login": "/acc/d/",
  "download": "/dl/",
  "download-modal-data": "/dl/mdl/",
  "download-redirect": "/dlr/",
  "drafting": "/drafts/",
  "edit-applicant-award-decision": "/sub/<app_id>/decision/",
  "filters-datasource": "/admin/filters/datasource/",
  "filters-delete": "/admin/filters/delete/",
  "filters-duplicate": "/admin/filters/duplicate/",
  "filters-get-filter": "/admin/filters/get/",
  "filters-index": "/admin/filters/",
  "filters-rename": "/admin/filters/rename/",
  "filters-save": "/admin/filters/save/",
  "filters-share": "/admin/filters/share/",
  "filters-unshare": "/admin/filters/unshare/",
  "generate-api-tokens": "/acc/api_tokens/",
  "get-collaborator-list": "/sub/<app_id>/gcl/",
  "get-collaborators": "/sub/<app_id>/gc/",
  "get-org-applicant-list": "/sub/<app_id>/gol/",
  "get-org-member-list": "/sub/<app_id>/gml/",
  "guidestar-organization": "/acc/gs/",
  "helpdesk": "/helpdesk/",
  "helpdesk-articles": "/helpdesk/articles/",
  "helpdesk-form-legacy": "/helpdesk/form/",
  "helpdesk-form-legacy-params": "/helpdesk/form/<selection>/",
  "in-gdpr-country": "/gdprgeo/",
  "make-collaborator-owner": "/sub/<app_id>/col/<member_id>/mo/",
  "modify-collaborator": "/sub/<app_id>/mc/",
  "org-eligibility": "/org/e/",
  "org-files": "/org/f/",
  "org-members": "/org/m/",
  "org-members-access": "/org/m/a/",
  "org-members-activate": "/org/m/ac/",
  "org-members-add": "/org/m/add/",
  "org-members-data": "/org/m/d/",
  "org-members-deactivate": "/org/m/de/",
  "org-members-email": "/org/m/em/",
  "org-members-import": "/org/m/im/",
  "org-members-import-template": "/org/m/im/t/",
  "org-members-invite": "/org/m/in/",
  "org-members-remove": "/org/m/rm/",
  "org-members-role": "/org/m/r/",
  "org-members-teams": "/org/m/tm/",
  "org-profile": "/org/p/",
  "org-profile-cancel-delete-request": "/org/p/r/d/c/",
  "org-profile-delete-request": "/org/p/r/d/",
  "org-profile-logo": "/org/p/l/",
  "org-profile-logo-remove": "/org/p/l/r/",
  "org-profile-transfer": "/org/p/t/",
  "org-sites-data": "/org/s/",
  "org-switch-profile": "/org/sw/",
  "org-teams": "/org/t/",
  "org-teams-create": "/org/t/c/",
  "org-teams-data": "/org/t/d/",
  "org-teams-email": "/org/t/em/",
  "org-teams-members-data": "/org/t/<team_id>/d/",
  "org-teams-members-remove": "/org/t/<team_id>/rm/",
  "org-teams-panel": "/org/t/<team_id>/p/",
  "org-teams-remove": "/org/t/rm/",
  "org-teams-rename": "/org/t/n/",
  "pipes-index": "/admin/pipes/",
  "program-apply": "/prog/<program_id>/apply/",
  "program-list": "/prog/lst/",
  "program-list-datasource": "/prog/ds/",
  "program-profile": "/prog/<listing_url>/",
  "recommender-account": "/acc/rcmdr/",
  "remove-collaborator": "/sub/<app_id>/col/<member_id>/rm/",
  "remove-profile-picture": "/acc/pp/rm/",
  "remove-team": "/sub/<app_id>/col/<team_id>/rt/",
  "resend-collaborator-invite": "/sub/<app_id>/col/<member_id>/rs/",
  "resend-email-confirmation": "/acc/em/rs/",
  "resend-email-verification": "/acc/em/vr/",
  "reviewer-account": "/acc/rev/",
  "reviewer-conflict-delete": "/acc/rev/conflicts/<conflict_id>/rm/",
  "reviewer-conflict-list": "/acc/rev/conflicts/",
  "reviewers-assignments-columns": "/rev/a/<award_id>/r/<round_id>/cols/",
  "reviewers-assignments-list": "/rev/a/<award_id>/r/<round_id>/",
  "reviewers-assignments-list-data": "/rev/a/<award_id>/r/<round_id>/data/",
  "reviewers-assignments-needs-submit": "/rev/a/<award_id>/r/<round_id>/sbmt/ns/",
  "reviewers-assignments-reopen": "/rev/a/<award_id>/r/<round_id>/ro/",
  "reviewers-assignments-submit": "/rev/a/<award_id>/r/<round_id>/sbmt/",
  "reviewers-assignments-submit-page": "/rev/a/<award_id>/r/<round_id>/sbmt/p/",
  "reviewers-download-all-reviews": "/rev/dl/all/<award_id>/<round_id>/",
  "reviewers-index": "/rev/",
  "reviewers-report-conflict": "/rev/conflict/<submission_id>/",
  "reviewers-reset-task": "/rev/reset-task/<award_id>/<round_id>/",
  "reviewers-review-mode": "/rev/a/<award_id>/r/<round_id>/s/<submission_id>/",
  "reviewers-reviews-tab": "/rev/a/<award_id>/r/<round_id>/s/<submission_id>/tab",
  "reviewers-round-instructions": "/rev/a/<award_id>/r/<round_id>/instructions/",
  "reviewers-task-quick-edit": "/rev/a/<award_id>/r/<round_id>/e/<submission_id>/",
  "reviewroom-apiv2-organization-member-list": "/api/v2/organizations/<pk>/members.<format>/",
  "reviewroom-apiv2-report-list": "/api/v2/reports.<format>/",
  "reviewroom-apiv2-round-detail-status-detail": "/api/v2/rounds/<pk>/statuses/<status_pk>.<format>/",
  "reviewroom-apiv2-round-detail-status-list": "/api/v2/rounds/<pk>/statuses.<format>/",
  "reviewroom-apiv2-submission-list": "/api/v2/submissions.<format>/",
  "reviewroom-apiv2-user-by-email": "/api/v2/user_by_email/<pk>.<format>/",
  "sf_index": "/admin/settings/integrations/salesforce_v4/",
  "sf_v4_auth_urls": "/admin/settings/integrations/salesforce_v4_api/auth_urls/",
  "sf_v4_automation": "/admin/settings/integrations/salesforce_v4_api/automations/<connection_pk>/<pk>/",
  "sf_v4_automation_get_run_jobs": "/admin/settings/integrations/salesforce_v4_api/automations/<connection_pk>/get_running_jobs/",
  "sf_v4_automation_run": "/admin/settings/integrations/salesforce_v4_api/automations/<connection_pk>/<pk>/run/",
  "sf_v4_automations": "/admin/settings/integrations/salesforce_v4_api/automations/<connection_pk>/",
  "sf_v4_automations_bulk": "/admin/settings/integrations/salesforce_v4_api/automations/<connection_pk>/bulk/",
  "sf_v4_callback": "/admin/settings/integrations/salesforce_v4_api/auth_callback/",
  "sf_v4_connection": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/",
  "sf_v4_connection_automation_schema": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/automation_schema/",
  "sf_v4_connection_mapping_schema": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/mapping_action_schema/",
  "sf_v4_connection_objects": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/objects/",
  "sf_v4_connection_reauth": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/reauth/",
  "sf_v4_connection_record_search": "/admin/settings/integrations/salesforce_v4_api/mapping_actions/<connection_pk>/<pk>/record_search/",
  "sf_v4_connection_unique_object_names": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/unique_object_names/",
  "sf_v4_connections_list": "/admin/settings/integrations/salesforce_v4_api/connections/",
  "sf_v4_logs": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/logs/",
  "sf_v4_logs_rerun": "/admin/settings/integrations/salesforce_v4_api/connections/<pk>/logs/<log_pk>/rerun/",
  "sf_v4_mapping_action": "/admin/settings/integrations/salesforce_v4_api/mapping_actions/<connection_pk>/<pk>/",
  "sf_v4_mapping_actions": "/admin/settings/integrations/salesforce_v4_api/mapping_actions/<connection_pk>/",
  "sf_v4_mapping_actions_bulk": "/admin/settings/integrations/salesforce_v4_api/mapping_actions/<connection_pk>/bulk/",
  "sf_v4_program": "/admin/settings/integrations/salesforce_v4_api/programs/",
  "sf_v4_source": "/admin/settings/integrations/salesforce_v4_api/sources/",
  "sf_v4_unpaginated_mapping_actions": "/admin/settings/integrations/salesforce_v4_api/mapping_actions/<connection_pk>/unpaginated/",
  "signout": "/acc/lo/",
  "submission-admin-stage-preview": "/rend/<submission_id>/admin/st/<stage_id>/",
  "submission-admin-taskrecord-preview": "/rend/<submission_id>/admin/t/<taskrecord_id>/",
  "submission-details-preview": "/rend/<submission_id>/dt/",
  "submission-recommender-stage-preview": "/rend/<submission_id>/rec/st/<stage_id>/",
  "submission-reviewer-stage-preview": "/rend/<submission_id>/rev/st/<stage_id>/",
  "submission-stage-preview": "/rend/<submission_id>/st/<stage_id>/",
  "submission-taskrecord-preview": "/rend/<submission_id>/t/<taskrecord_id>/",
  "surveys-bulk": "/admin/surveys/bulk/",
  "surveys-datasource": "/admin/surveys/<survey_id>/datasource/",
  "surveys-download": "/admin/surveys/<survey_id>/download/",
  "surveys-pipes-datasource": "/admin/surveys/<survey_id>/pipesdatasource/",
  "surveys-preview": "/admin/surveys/<survey_id>/preview/",
  "surveys-preview-save": "/admin/surveys/<survey_id>/previewsave/",
  "surveys-save": "/admin/surveys/<survey_id>/save/",
  "surveys-versions": "/admin/surveys/<survey_id>/versions/datasource/",
  "surveys-versions-revert": "/admin/surveys/<survey_id>/versions/<version_id>/revert/",
  "task-file-attachment-delete": "/tsk/<submission_id>/flup/<task_record_id>/delete/<file_attachment_id>/",
  "task-file-attachment-list": "/tsk/<submission_id>/flup/<task_record_id>/list/",
  "task-file-attachment-preview": "/tsk/<submission_id>/flup/<task_record_id>/preview/<file_attachment_id>/",
  "task-file-edit-file": "/tsk/<submission_id>/flup/<task_record_id>/e/file/<file_attachment_id>/",
  "task-file-edit-link": "/tsk/<submission_id>/flup/<task_record_id>/e/link/<file_attachment_id>/",
  "task-file-upload-file": "/tsk/<submission_id>/flup/<task_record_id>/upload/file/",
  "task-file-upload-link": "/tsk/<submission_id>/flup/<task_record_id>/upload/link/",
  "task-form-guidestar-values": "/tsk/<submission_id>/frm/<task_record_id>/guidestar/",
  "task-global-reuse": "/tsk/<submission_id>/gt/<task_record_id>/",
  "task-reopen": "/tsk/<submission_id>/rpn/<task_record_id>/",
  "task-reset": "/tsk/<submission_id>/rst/<task_record_id>/"
};

function reverse(urlname, kwargs) {
  var url = viewnames[urlname];
  kwargs = kwargs || {};

  if (url === undefined) {
    throw 'reverse failed. Incorrect urlname: ' + urlname;
  }

  for (var kwarg in kwargs) {
    var value = kwargs[kwarg];
    url = url.replace('<' + kwarg + '>', value);
  }
  if (url.includes('<')) {
    throw 'reverse failed. Missing kwargs. urlname: ' + urlname + '. kwargs: ' + JSON.stringify(kwargs) + '. url: ' + url;
  }
  return url;
}
window.reverse = reverse;

/***/ }),

/***/ 2453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _modals = __webpack_require__(6);

$(function () {
	$('.ajax-modal').click(function (e) {
		e.preventDefault();
		var $modalButton = $(this);
		var modalUrl = $modalButton.data('url') || $modalButton.attr('href');
		var size = $modalButton.data('size') || 'md';
		var modal = new _modals.AjaxFormModal({
			size: size,
			destroyOnClose: true
		});

		modal.addToStack('modal', new _modals.AjaxFormContent(modalUrl, { onLoad: function onLoad() {
				modal.show();
			} }));
	});
});

/***/ }),

/***/ 2454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _timers = __webpack_require__(300);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DRAFT_URL = reverse('drafting');
var savedTempl = __webpack_require__(2455);
var errorTempl = __webpack_require__(2456);

var _require = __webpack_require__(6),
    Confirm = _require.Confirm,
    Notify = _require.Notify;

var STRINGS = {
	draft_saved: gettext('Draft saved'),
	draft: gettext('Draft'),
	draft_delete: gettext('Delete current draft'),
	logged_out: gettext('You are currently logged out'),
	error: gettext('Error: Drafting mode disabled')
};

var Drafting = function () {
	_createClass(Drafting, null, [{
		key: 'getHash',
		value: function getHash(obj) {
			return JSON.stringify(obj);
		}
	}, {
		key: 'populateForm',
		value: function populateForm(serialized) {
			serialized.forEach(function (entry) {
				var el = $('[name="' + entry.name + '"]');
				var type = el.attr('type');
				var value = entry.value,
				    state = entry.state;


				switch (type) {
					case 'checkbox':
						if (state && state === 'off') {
							el.filter('[value="' + value + '"]').prop('checked', false);
							el.change();
						} else if (state && state === 'on') {
							el.filter('[value="' + value + '"]').prop('checked', true);
							el.change();
						}
						break;

					case 'radio':
						el.filter('[value="' + value + '"]').prop('checked', true);
						el.change();
						break;

					case 'hidden':
						if (el.hasClass('sma-i18n-field')) {
							el.val(value);
							el.change();
						}
						break;

					default:
						if (value === '' && el.val()) {
							// Don't blank out existing strings
							break;
						}
						el.val(value);
						el.change();
				}
				el.trigger('draft-loaded');
			});
		}
	}]);

	function Drafting(form) {
		_classCallCheck(this, Drafting);

		this.errors = {
			400: 'invalid',
			500: 'serverError'
		};

		this.loggedOutNotified = false;
		this.form = form;
		this.updateTimeout = null;
		this.path = form.data('sma-js-drafting-path') || window.location.toString();
		this.scope = form.data('sma-js-drafting-scope') || 'admin';
		this.target = form.data('sma-js-drafting-target') || null;
		this.isSaving = false;
		this.disabled = false;

		this.element = $('<div></div>', {
			class: 'sma-draft-notification'
		});

		this.placeElement();
		this.initial = this.serializeForm();
		this.load();
	}

	_createClass(Drafting, [{
		key: 'placeElement',
		value: function placeElement() {
			if ($('.sma-button-footer').length > 0) {
				$('.sma-button-footer-right').prepend(this.element);
			} else if ($('.sma-nav').length > 0) {
				$('.sma-nav .sma-navbar-name').after(this.element);
			} else if ($('#survey').length > 0) {
				$('#survey').prepend(this.element.css('float', 'right'));
			} else {
				this.form.prepend(this.element);
			}
		}
	}, {
		key: 'bindElement',
		value: function bindElement(el) {
			var _this = this;

			$(el).bind('change input', function (e) {
				if (_this.updateTimeout) {
					clearTimeout(_this.updateTimeout);
				}

				_this.updateTimeout = (0, _timers.setTimeout)(function () {
					_this.update(e, $(e.currentTarget));
				}, 4000);
			});
		}

		/**
   * This is to bind the functionality UI events.
   *
   * @memberof Drafting
   */

	}, {
		key: 'bind',
		value: function bind() {
			var _this2 = this;

			this.form.find('[name]').each(function (i, el) {
				_this2.bindElement(el);
			});

			this.element.delegate('.sma-js-delete-draft', 'click', function () {
				/* eslint-disable no-new */
				new Confirm(gettext('Delete draft'), gettext('Are you sure you want to delete this draft?'), function () {
					_this2.deleteDraft(true);
				});
				/* eslint-enable no-new */
			});

			this.form.submit(function () {
				_this2.disabled = true;

				if (_this2.updateTimeout) {
					clearTimeout(_this2.updateTimeout);
				}

				_this2.deleteDraft(false);

				return true;
			});
		}
	}, {
		key: 'load',
		value: function load() {
			var _this3 = this;

			$.get(DRAFT_URL, {
				path: this.path,
				scope: this.scope,
				target: this.target
			}, function (response) {
				if (response.status >= 400 && response.status <= 499) {
					_this3.notifyError(response, _this3.errors['400']);
				} else if (response.status >= 500 && response.status <= 599) {
					_this3.notifyError(response, _this3.errors['500']);
				} else if (response.success) {
					_this3.loaded(response);
				}
				_this3.bind();
			}, 'json');
		}
	}, {
		key: 'loaded',
		value: function loaded(response) {
			this.element.text(gettext('Loading draft...'));

			try {
				Drafting.populateForm(response.fields);
			} catch (e) {
				this.notifyError(response, this.errors['500']);
			}

			this.lastHash = Drafting.getHash(response.fields || {});
			this.notifyLoaded(response);
		}
	}, {
		key: 'serializeForm',
		value: function serializeForm() {
			var data = _.filter(this.form.serializeArray(), function (item) {
				return item.name !== 'csrfmiddlewaretoken';
			});

			data = data.concat($('input[type=checkbox]', this.form).map(function (index, checkbox) {
				return {
					name: checkbox.name,
					value: checkbox.value,
					state: $(checkbox).is(':checked') ? 'on' : 'off'
				};
			}).get());

			return data;
		}
	}, {
		key: 'update',
		value: function update() {
			var _this4 = this;

			if (!this.disabled) {
				var data = this.serializeForm();
				var hash = Drafting.getHash(data);

				if (hash !== this.lastHash && !this.isSaving) {
					this.lastHash = hash;
					this.isSaving = true;
					this.element.text(gettext('Saving draft...'));

					$.post(DRAFT_URL, {
						action: 'update',
						path: this.path,
						scope: this.scope,
						target: this.target,
						data: JSON.stringify(data)
					}, function (response) {
						if (response.status >= 400 && response.status <= 499) {
							_this4.notifyError(response, _this4.errors['400']);
						} else if (response.status >= 500 && response.status <= 599) {
							_this4.notifyError(response, _this4.errors['500']);
						} else if (response.success) {
							_this4.notify(response);
						}
						_this4.isSaving = false;
					}, 'json').fail(function (response) {
						if (response.status === 403 || response.status === 401) {
							_this4.notifyError(response, _this4.errors['400']);
						} else {
							_this4.notifyError(response, _this4.errors['500']);
						}
					});
				}
			}
		}
	}, {
		key: 'deleteDraft',
		value: function deleteDraft(reload) {
			var _this5 = this;

			this.element.text(gettext('Deleting...'));

			$.post(DRAFT_URL, {
				action: 'delete',
				path: this.path,
				scope: this.scope,
				target: this.target
			}, function (response) {
				if (response.status >= 400 && response.status <= 499) {
					_this5.notifyError(response, _this5.errors['400']);
				} else if (response.status >= 500 && response.status <= 599) {
					_this5.notifyError(response, _this5.errors['500']);
				} else if (response.success) {
					_this5.element.empty();
					if (reload) {
						window.location.reload(true);
					}
				}
			}, 'json');
		}

		/**
   * Update drafting messaging
   *
   * @param {*} response
   * @memberof Drafting
   */

	}, {
		key: 'notify',
		value: function notify(response) {
			var _this6 = this;

			(0, _timers.setTimeout)(function () {
				response.strings = STRINGS;
				var el = $(savedTempl(response));
				_this6.element.html(el);

				if ($().tooltip) {
					el.tooltip();
				}
			}, 1000);
		}

		/**
   * Will notify a user that they are logged out.  This can happen after an Ajax request that returns
   * an HTTP 401.
   *
   * @param {*} response
   * @memberof Drafting
   */

	}, {
		key: 'notifyError',
		value: function notifyError(response, errorType) {
			if (errorType === this.errors['400']) {
				if (!this.loggedOutNotified) {
					/* eslint-disable no-new */
					new Notify(gettext('Logged out!'), gettext('You have been logged out by the system.  Your changes cannot be saved.  ' + 'Please log back in to ensure your work is not lost'), gettext('Ok'), function () {});
					/* eslint-enable no-new */
					this.loggedOutNotified = true;
				}
				response.invalid = true;
			} else {
				// errorType === 500
				response.unknown = true;
			}

			response.strings = STRINGS;
			var el = $(errorTempl(response));
			this.element.html(el);

			if ($().tooltip) {
				el.tooltip();
			}
		}

		/**
   * Helper method to help notify that the draft has been loaded
   *
   * @param {*} response
   * @memberof Drafting
   */

	}, {
		key: 'notifyLoaded',
		value: function notifyLoaded(response) {
			response.loaded = true;
			this.notify(response);
		}
	}]);

	return Drafting;
}();

$(function () {
	(0, _timers.setTimeout)(function () {
		$('[data-sma-js-drafting]').each(function (i, form) {
			/* eslint-disable no-new */
			new Drafting($(form));
			/* eslint-enable no-new */
		});
	}, 100);
});

module.exports = Drafting;

/***/ }),

/***/ 2455:
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<span data-toggle=\"tooltip\" data-placement=\"left\" title=\"");t.b(t.v(t.d("strings.draft_saved",c,p,0)));t.b(" ");t.b(t.v(t.f("last_edited",c,p,0)));t.b(" (");t.b(t.v(t.f("author",c,p,0)));t.b(")\">");t.b("\n" + i);if(t.s(t.f("loaded",c,p,1),c,p,0,124,146,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("		");t.b(t.v(t.d("strings.draft",c,p,0)));t.b("\n" + i);});c.pop();}if(!t.s(t.f("loaded",c,p,1),c,p,1,0,0,"")){t.b("		<i class=\"nc-icon-mini ui-1_check-simple\" aria-hidden=\"true\"></i>");t.b("\n" + i);t.b("		");t.b(t.v(t.d("strings.draft_saved",c,p,0)));t.b("\n" + i);};t.b("\n" + i);t.b("	<a href=\"#\" class=\"sma-js-delete-draft\">");t.b("\n" + i);t.b("		<i class=\"nc-icon-mini ui-1_trash-simple\" aria-hidden=\"true\"></i>");t.b("\n" + i);t.b("		<span class=\"sr-only\">");t.b("\n" + i);t.b("			");t.b(t.v(t.d("strings.draft_delete",c,p,0)));t.b("\n" + i);t.b("		</span>");t.b("\n" + i);t.b("	</a>");t.b("\n" + i);t.b("</span>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<span data-toggle=\"tooltip\" data-placement=\"left\" title=\"{{strings.draft_saved}} {{last_edited}} ({{author}})\">\n\t{{#loaded}}\n\t\t{{strings.draft}}\n\t{{/loaded}}\n\t{{^loaded}}\n\t\t<i class=\"nc-icon-mini ui-1_check-simple\" aria-hidden=\"true\"></i>\n\t\t{{ strings.draft_saved }}\n\t{{/loaded}}\n\n\t<a href=\"#\" class=\"sma-js-delete-draft\">\n\t\t<i class=\"nc-icon-mini ui-1_trash-simple\" aria-hidden=\"true\"></i>\n\t\t<span class=\"sr-only\">\n\t\t\t{{ strings.draft_delete }}\n\t\t</span>\n\t</a>\n</span>\n", H);return T.render.apply(T, arguments); };

/***/ }),

/***/ 2456:
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<span data-toggle=\"tooltip\" data-placement=\"left\" title=\"");t.b(t.v(t.d("strings.warning",c,p,0)));t.b("\" class=\"sma-bengal\">");t.b("\n" + i);t.b("	<i class=\"nc-icon-mini ui-3_alert sma-bengal\" aria-hidden=\"true\"></i>");t.b("\n" + i);if(t.s(t.f("invalid",c,p,1),c,p,0,182,222,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("		<span>");t.b(t.v(t.d("strings.logged_out",c,p,0)));t.b("</span>");t.b("\n" + i);});c.pop();}if(t.s(t.f("unknown",c,p,1),c,p,0,248,283,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("		<span>");t.b(t.v(t.d("strings.error",c,p,0)));t.b("</span>");t.b("\n" + i);});c.pop();}t.b("</span>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<span data-toggle=\"tooltip\" data-placement=\"left\" title=\"{{strings.warning}}\" class=\"sma-bengal\">\n\t<i class=\"nc-icon-mini ui-3_alert sma-bengal\" aria-hidden=\"true\"></i>\n\t{{#invalid}}\n\t\t<span>{{strings.logged_out}}</span>\n\t{{/invalid}}\n\t{{#unknown}}\n\t\t<span>{{strings.error}}</span>\n\t{{/unknown}}\n</span>\n", H);return T.render.apply(T, arguments); };

/***/ }),

/***/ 2457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cookies = __webpack_require__(308);

$(function () {
    var redirect = Cookies.get('sma-redirect');

    if (redirect && window.USER) {
        Cookies.remove('sma-redirect');
        window.location = redirect;
    }
});

/***/ }),

/***/ 2458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LANG = window.__LANGUAGE || 'en';

var STRINGS = [
// Mark any strings the need to be added to po files
gettext('Choose file...'), gettext('Browse')];

var localize = function localize() {
	if (LANG) {
		jQuery.extend(jQuery.fn.pickadate.defaults, {
			today: gettext('Today'),
			clear: gettext('Clear'),
			close: gettext('Close'),
			firstDay: 1,
			labelMonthNext: gettext('Next month'),
			labelMonthPrev: gettext('Previous month'),
			labelMonthSelect: gettext('Choose month'),
			labelYearSelect: gettext('Choose year')
		});

		if (/fr/.test(LANG)) {
			jQuery.extend(jQuery.fn.pickadate.defaults, {
				monthsFull: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'décembre'],
				monthsShort: ['janv.', 'févr.', 'mars', 'avril', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
				weekdaysFull: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
				weekdaysShort: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam']
			});
		}
	}

	$('.custom-file-control').attr('lang', LANG);
};

$(localize);

window.localize = localize;

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var templates = {
	base: __webpack_require__(458),
	block: __webpack_require__(459)
};

var Slideout = function () {
	_createClass(Slideout, [{
		key: '$bottomBarRight',
		get: function get() {
			return this.base.find('.sma-slideout-bottom-bar-right');
		}
	}, {
		key: '$bottomBarLeft',
		get: function get() {
			return this.base.find('.sma-slideout-bottom-bar-right');
		}
	}]);

	function Slideout(config) {
		_classCallCheck(this, Slideout);

		if (config === undefined) {
			config = {};
		}
		this.bodyWidth = config.bodyWidth || 'col-md-7';

		this.base = $(templates.base({
			bodyWidth: this.bodyWidth
		}));

		this.blocking = config.nonBlocking === undefined ? true : config.nonBlocking;

		if (this.blocking) {
			this.block = $(templates.block());
			this.block.hide();
			$('body').append(this.block);
		}

		if (config.body !== undefined) {
			this.setBody(config.body);
		}

		if (config.buttons !== undefined) {
			this.setBottomBarRight(config.buttons);
		}

		this.base.on('click', '.sma-slideout-close', $.proxy(this.close, this));

		$('body').append(this.base);
	}

	_createClass(Slideout, [{
		key: 'setBody',
		value: function setBody(body) {
			this.base.find('.sma-slideout-body').empty();
			this.base.find('.sma-slideout-body').append(body);
		}
	}, {
		key: 'setTitle',
		value: function setTitle(text) {
			this.base.find('.sma-slideout-title-text').html(text);
		}
	}, {
		key: 'setBottomBarRight',
		value: function setBottomBarRight(content) {
			this.$bottomBarRight.empty();
			this.$bottomBarRight.append(content);
		}
	}, {
		key: 'showBlock',
		value: function showBlock() {
			if (!this.blocking) {
				return;
			}

			this.block.fadeIn(300);
			this.block.find('.sma-slideout-block-spinner').fadeIn(300);
		}
	}, {
		key: 'open',
		value: function open() {
			if (this.blocking) {
				if (!this.block.is(':visible')) {
					this.showBlock();
					this.block.find('.sma-slideout-block-spinner').hide();
				} else {
					this.block.find('.sma-slideout-block-spinner').fadeOut(300);
				}
			}
			this.base.addClass('sma-slideout-show');

			this.base.trigger('smaslideout:opened', this);
		}
	}, {
		key: 'close',
		value: function close() {
			this.base.removeClass('sma-slideout-show');

			if (this.blocking) {
				this.hideBlock();
			}

			this.base.trigger('smaslideout:closed', this);
		}
	}, {
		key: 'hideBlock',
		value: function hideBlock() {
			this.block.fadeOut(500);
		}
	}]);

	return Slideout;
}();

;

module.exports = Slideout;

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectSearch = function (_Backbone$View) {
    _inherits(SelectSearch, _Backbone$View);

    function SelectSearch() {
        _classCallCheck(this, SelectSearch);

        return _possibleConstructorReturn(this, (SelectSearch.__proto__ || Object.getPrototypeOf(SelectSearch)).apply(this, arguments));
    }

    _createClass(SelectSearch, [{
        key: 'initialize',
        value: function initialize(config) {
            this.setElement($('body'));
        }
    }, {
        key: 'clickedContainer',
        value: function clickedContainer(e) {
            e.stopPropagation();
        }
    }, {
        key: 'selectOption',
        value: function selectOption(e) {
            var $target = $(e.currentTarget);
            $target.closest('.sma-select-content').find('.sma-checkbox-input').prop('checked', false);
            $target.prop('checked', true);
            $target.closest('.dropdown.show').removeClass('show');
            this.$el.find('.sma-select-dropdown-button').html($target.next().text());
        }
    }, {
        key: 'onSearchInput',
        value: function onSearchInput(e) {
            var checkboxes = $(e.currentTarget).closest('.sma-select-menu').find('.sma-select-row');

            checkboxes.each(function (i, checkbox) {
                if ($(checkbox).find('label').text().toLowerCase().includes($('.sma-select-search').val().toLowerCase())) {
                    $(checkbox).show();
                } else {
                    $(checkbox).hide();
                }
            });
        }
    }, {
        key: 'events',
        get: function get() {
            return {
                'click .sma-select-menu': 'clickedContainer',
                'click .sma-select-row .sma-checkbox-input': 'selectOption',
                'input .sma-select-search': 'onSearchInput'
            };
        }
    }]);

    return SelectSearch;
}(Backbone.View);

module.exports = {
    SelectSearch: SelectSearch
};

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"");t.b(t.v(t.f("bodyWidth",c,p,0)));t.b(" sma-slideout-pane\">");t.b("\n" + i);t.b("	<div class=\"row sma-slideout-title-bar\">");t.b("\n" + i);t.b("		<div class=\"col-md-11\">");t.b("\n" + i);t.b("			<h1 class=\"sma-slideout-title-text\"></h1>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("		<div class=\"col-md-1 text-sm-right\">");t.b("\n" + i);t.b("			<a class=\"sma-slideout-close\" href=\"#\"><i class=\"nc-icon-mini ui-1_simple-remove\"></i></a>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("	<div class=\"sma-slideout-body\">");t.b("\n");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("	<div class=\"sma-slideout-bottom-bar row\">");t.b("\n" + i);t.b("		<div class=\"col-md-6 sma-slideout-bottom-bar-left\"></div>");t.b("\n" + i);t.b("		<div class=\"col-md-6 text-right sma-slideout-bottom-bar-right\">");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"{{bodyWidth}} sma-slideout-pane\">\n\t<div class=\"row sma-slideout-title-bar\">\n\t\t<div class=\"col-md-11\">\n\t\t\t<h1 class=\"sma-slideout-title-text\"></h1>\n\t\t</div>\n\t\t<div class=\"col-md-1 text-sm-right\">\n\t\t\t<a class=\"sma-slideout-close\" href=\"#\"><i class=\"nc-icon-mini ui-1_simple-remove\"></i></a>\n\t\t</div>\n\t</div>\n\t<div class=\"sma-slideout-body\">\n\n\t</div>\n\t<div class=\"sma-slideout-bottom-bar row\">\n\t\t<div class=\"col-md-6 sma-slideout-bottom-bar-left\"></div>\n\t\t<div class=\"col-md-6 text-right sma-slideout-bottom-bar-right\">\n\t\t</div>\n\t</div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-slideout-block\">");t.b("\n" + i);t.b("	<i class=\"sma-slideout-block-spinner nc-icon-glyph loader_circle-04 spin\"></i>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-slideout-block\">\n\t<i class=\"sma-slideout-block-spinner nc-icon-glyph loader_circle-04 spin\"></i>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = __webpack_require__(53);

var _require = __webpack_require__(27),
    randomString = _require.randomString;

var templates = {
	body: __webpack_require__(461),
	groupContainer: __webpack_require__(462),
	item: __webpack_require__(463)
};

var MultiSelect = function () {
	function MultiSelect(config) {
		_classCallCheck(this, MultiSelect);

		if (config === undefined) {
			config = {};
		}

		this.element = $(templates.body({
			strings: {
				search: gettext('Search...')
			}
		}));

		this.groupCounter = 0;

		this.items = [];

		if (config.items !== undefined) {
			this._parseItems(config.items);
		}

		if (config.appendTo !== undefined) {
			this.element.appendTo(config.appendTo);
		}

		var noop = function noop() {};

		this.callbacks = {
			itemSelected: config.itemSelected || noop,
			itemDeselected: config.itemDeselected || noop,
			selectionChanged: config.selectionChanged || noop
		};

		//options to add
		// + show selection count
		// + show or hide search
		// + confirm buttons
		// + popup mode

		this.bindEvents();
	}

	_createClass(MultiSelect, [{
		key: 'bindEvents',
		value: function bindEvents() {
			this.$searchInput.on('input', _.debounce($.proxy(this._searchInput, this), 100));

			this.element.on('change', 'input[type="checkbox"]', $.proxy(this._selectionChanged, this));
		}
	}, {
		key: '_selectionChanged',
		value: function _selectionChanged(e) {
			var target = $(e.currentTarget);
			var item = this.getItemByValue(target.val());

			if (target.is(':checked')) {
				this.callbacks.itemSelected(this, item);
			} else {
				this.callbacks.itemDeselected(this, item);
			}

			this.callbacks.selectionChanged(this);
		}
	}, {
		key: '_searchInput',
		value: function _searchInput(e) {
			if (this.$searchInput.val().trim().length > 0) {
				this.search(this.$searchInput.val().trim());
			} else {
				this.clearSearch();
			}
		}
	}, {
		key: '_parseItems',
		value: function _parseItems(items) {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var item = _step.value;

					if (item.hasOwnProperty('items')) {
						var composedGroup = this._buildGroup(item);

						this._pushItem(composedGroup);
					} else {
						var composedItem = this._buildItem(item);

						this._pushItem(composedItem);
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		}
	}, {
		key: '_pushItem',
		value: function _pushItem(item) {
			this.$items.append(item.element);
			this.items.push(item);
		}
	}, {
		key: '_pushItemToGroup',
		value: function _pushItemToGroup(item, group) {
			group.element.find('.sma-select-multi-group-items').append(item.element);
			group.items.push(item);
		}
	}, {
		key: '_buildGroup',
		value: function _buildGroup(group) {
			var groupElement = $(templates.groupContainer(group));

			this.groupCounter++;

			var composedGroup = {
				element: groupElement,
				isGroup: true,
				label: group.label,
				key: group.key || this.groupCounter,
				items: []
			};

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = group.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var item = _step2.value;

					var composedItem = this._buildItem(item);

					this._pushItemToGroup(composedItem, composedGroup);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			return composedGroup;
		}
	}, {
		key: '_buildItem',
		value: function _buildItem(item) {
			var itemWithUid = Object.assign({}, item);
			itemWithUid.uid = randomString(10) + item.value.toString();

			var itemElement = $(templates.item(itemWithUid));

			return {
				element: itemElement,
				isGroup: false,
				label: item.label,
				value: item.value
			};
		}
	}, {
		key: 'getSelectedCount',
		value: function getSelectedCount() {
			return this.$items.find('input[type="checkbox"]:checked').length;
		}
	}, {
		key: 'getSelectedItems',
		value: function getSelectedItems() {
			var selected = [];

			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = this.items[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var item = _step3.value;

					if (item.isGroup) {
						var _iteratorNormalCompletion4 = true;
						var _didIteratorError4 = false;
						var _iteratorError4 = undefined;

						try {
							for (var _iterator4 = item.items[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
								var _groupItem = _step4.value;

								if (_groupItem.element.find('input').is(':checked')) {
									selected.push(_groupItem);
								}
							}
						} catch (err) {
							_didIteratorError4 = true;
							_iteratorError4 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion4 && _iterator4.return) {
									_iterator4.return();
								}
							} finally {
								if (_didIteratorError4) {
									throw _iteratorError4;
								}
							}
						}
					} else {
						if (item.element.find('input').is(':checked')) {
							selected.push(groupItem);
						}
					}
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}

			return selected;
		}
	}, {
		key: 'getGroup',
		value: function getGroup(key) {
			var _iteratorNormalCompletion5 = true;
			var _didIteratorError5 = false;
			var _iteratorError5 = undefined;

			try {
				for (var _iterator5 = this.items[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
					var item = _step5.value;

					if (item.isGroup && item.key == key) {
						return item;
					}
				}
			} catch (err) {
				_didIteratorError5 = true;
				_iteratorError5 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion5 && _iterator5.return) {
						_iterator5.return();
					}
				} finally {
					if (_didIteratorError5) {
						throw _iteratorError5;
					}
				}
			}

			return null;
		}
	}, {
		key: 'getSelectedValues',
		value: function getSelectedValues() {
			return this.getSelectedItems().map(function (i) {
				return i.value;
			});
		}
	}, {
		key: 'addItem',
		value: function addItem(item, groupKey) {
			var composedItem = this._buildItem(item);

			if (groupKey !== undefined) {
				var group = this.getGroup(groupKey);

				if (group != null) {
					this._pushItemToGroup(item, group);
				}
			} else {
				this._pushItem(composedItem);
			}
		}
	}, {
		key: 'getItemByValue',
		value: function getItemByValue(value) {
			var _iteratorNormalCompletion6 = true;
			var _didIteratorError6 = false;
			var _iteratorError6 = undefined;

			try {
				for (var _iterator6 = this.items[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
					var item = _step6.value;

					if (item.isGroup) {
						var _iteratorNormalCompletion7 = true;
						var _didIteratorError7 = false;
						var _iteratorError7 = undefined;

						try {
							for (var _iterator7 = item.items[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
								var _groupItem2 = _step7.value;

								if (_groupItem2.value == value) {
									return _groupItem2;
								}
							}
						} catch (err) {
							_didIteratorError7 = true;
							_iteratorError7 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion7 && _iterator7.return) {
									_iterator7.return();
								}
							} finally {
								if (_didIteratorError7) {
									throw _iteratorError7;
								}
							}
						}
					} else {
						if (item.value == value) {
							return item;
						}
					}
				}
			} catch (err) {
				_didIteratorError6 = true;
				_iteratorError6 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion6 && _iterator6.return) {
						_iterator6.return();
					}
				} finally {
					if (_didIteratorError6) {
						throw _iteratorError6;
					}
				}
			}

			return null;
		}
	}, {
		key: 'disableItem',
		value: function disableItem(value) {
			var item = this.getItemByValue(value);

			if (item == null) return;

			item.element.find('.custom-control').addClass('disabled');
			item.element.find('input').attr('disabled', 'disabled');
		}
	}, {
		key: 'enableItem',
		value: function enableItem(value) {
			var item = this.getItemByValue(value);

			if (item == null) return;

			item.element.find('.custom-control').removeClass('disabled');
			item.element.find('input').removeAttr('disabled');
		}
	}, {
		key: 'hideItem',
		value: function hideItem(value) {
			var item = this.getItemByValue(value);

			if (item == null) return;

			item.element.hide();
		}
	}, {
		key: 'showItem',
		value: function showItem(value) {
			var item = this.getItemByValue(value);

			if (item == null) return;

			item.element.show();
		}
	}, {
		key: 'selectItem',
		value: function selectItem(value) {
			var item = this.getItemByValue(value);

			if (item == null) return;

			item.element.find('input').attr('checked', 'checked');
		}
	}, {
		key: 'deselectItem',
		value: function deselectItem(value) {
			var item = this.getItemByValue(value);

			if (item == null) return;

			item.element.find('input').removeAttr('checked');
		}
	}, {
		key: 'search',
		value: function search(query) {
			query = query.toLowerCase();

			var _iteratorNormalCompletion8 = true;
			var _didIteratorError8 = false;
			var _iteratorError8 = undefined;

			try {
				for (var _iterator8 = this.items[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
					var item = _step8.value;

					if (item.isGroup) {
						//If the group label is matched in the search show the whole group
						if (item.label.toLowerCase().indexOf(query) > -1) {
							var _iteratorNormalCompletion9 = true;
							var _didIteratorError9 = false;
							var _iteratorError9 = undefined;

							try {
								for (var _iterator9 = item.items[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
									var _groupItem3 = _step9.value;

									_groupItem3.element.show();
								}
							} catch (err) {
								_didIteratorError9 = true;
								_iteratorError9 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion9 && _iterator9.return) {
										_iterator9.return();
									}
								} finally {
									if (_didIteratorError9) {
										throw _iteratorError9;
									}
								}
							}

							continue;
						}

						var hasFoundItem = false;
						var _iteratorNormalCompletion10 = true;
						var _didIteratorError10 = false;
						var _iteratorError10 = undefined;

						try {
							for (var _iterator10 = item.items[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
								var _groupItem4 = _step10.value;

								if (_groupItem4.label.toLowerCase().indexOf(query) == -1) {
									_groupItem4.element.hide();
								} else {
									hasFoundItem = true;
									_groupItem4.element.show();
								}
							}
						} catch (err) {
							_didIteratorError10 = true;
							_iteratorError10 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion10 && _iterator10.return) {
									_iterator10.return();
								}
							} finally {
								if (_didIteratorError10) {
									throw _iteratorError10;
								}
							}
						}

						if (!hasFoundItem) {
							//Hide the whole group
							item.element.hide();
						} else {
							item.element.show();
						}
					} else {
						if (item.label.toLowerCase().indexOf(query) == -1) {
							item.element.hide();
						} else {
							item.element.show();
						}
					}
				}
			} catch (err) {
				_didIteratorError8 = true;
				_iteratorError8 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion8 && _iterator8.return) {
						_iterator8.return();
					}
				} finally {
					if (_didIteratorError8) {
						throw _iteratorError8;
					}
				}
			}
		}
	}, {
		key: 'clearSearch',
		value: function clearSearch() {
			var _iteratorNormalCompletion11 = true;
			var _didIteratorError11 = false;
			var _iteratorError11 = undefined;

			try {
				for (var _iterator11 = this.items[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
					var item = _step11.value;

					item.element.show();

					if (item.isGroup) {
						var _iteratorNormalCompletion12 = true;
						var _didIteratorError12 = false;
						var _iteratorError12 = undefined;

						try {
							for (var _iterator12 = item.items[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
								var _groupItem5 = _step12.value;

								_groupItem5.element.show();
							}
						} catch (err) {
							_didIteratorError12 = true;
							_iteratorError12 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion12 && _iterator12.return) {
									_iterator12.return();
								}
							} finally {
								if (_didIteratorError12) {
									throw _iteratorError12;
								}
							}
						}
					}
				}
			} catch (err) {
				_didIteratorError11 = true;
				_iteratorError11 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion11 && _iterator11.return) {
						_iterator11.return();
					}
				} finally {
					if (_didIteratorError11) {
						throw _iteratorError11;
					}
				}
			}
		}
	}, {
		key: '$items',
		get: function get() {
			return this.element.find('.sma-select-multi-items');
		}
	}, {
		key: '$searchContainer',
		get: function get() {
			return this.element.find('.sma-select-multi-search-container');
		}
	}, {
		key: '$searchInput',
		get: function get() {
			return this.element.find('input.sma-select-multi-search');
		}
	}]);

	return MultiSelect;
}();

module.exports = MultiSelect;

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-select-multi\">");t.b("\n" + i);t.b("	<div class=\"sma-select-multi-search-container\">");t.b("\n" + i);t.b("		<div class=\"sma-input-icon-right\">");t.b("\n" + i);t.b("			<input class=\"form-control sma-select-multi-search\" type=\"text\" placeholder=\"");t.b(t.v(t.d("strings.search",c,p,0)));t.b("\">");t.b("\n" + i);t.b("			<i class=\"nc-icon-mini ui-1_zoom\"></i>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n");t.b("\n" + i);t.b("	<div class=\"sma-select-multi-items\">");t.b("\n" + i);t.b("	</div>");t.b("\n");t.b("\n" + i);t.b("	<div class=\"sma-select-multi-footer\">");t.b("\n" + i);t.b("		<div class=\"sma-select-multi-selected-counter\">");t.b("\n" + i);t.b("			<span class=\"sma-select-multi-selected-count\">");t.b(t.v(t.f("checked_items|length",c,p,0)));t.b("</span><span> ");t.b(t.v(t.f("_('selected')",c,p,0)));t.b("</span>");t.b("\n" + i);t.b("		</div>");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-select-multi\">\n\t<div class=\"sma-select-multi-search-container\">\n\t\t<div class=\"sma-input-icon-right\">\n\t\t\t<input class=\"form-control sma-select-multi-search\" type=\"text\" placeholder=\"{{strings.search}}\">\n\t\t\t<i class=\"nc-icon-mini ui-1_zoom\"></i>\n\t\t</div>\n\t</div>\n\n\t<div class=\"sma-select-multi-items\">\n\t</div>\n\n\t<div class=\"sma-select-multi-footer\">\n\t\t<div class=\"sma-select-multi-selected-counter\">\n\t\t\t<span class=\"sma-select-multi-selected-count\">{{ checked_items|length }}</span><span> {{ _('selected') }}</span>\n\t\t</div>\n\t</div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-select-multi-group-container\">");t.b("\n" + i);t.b("	<h5>");t.b(t.v(t.f("label",c,p,0)));t.b("</h5>");t.b("\n" + i);t.b("	<div class=\"sma-select-multi-group-items\">");t.b("\n" + i);t.b("	</div>");t.b("\n" + i);t.b("</div>");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-select-multi-group-container\">\n\t<h5>{{label}}</h5>\n\t<div class=\"sma-select-multi-group-items\">\n\t</div>\n</div>", H);return T.render.apply(T, arguments); };

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

var H = __webpack_require__(0);
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<div class=\"sma-select-multi-item\">");t.b("\n" + i);t.b("	<label class=\"custom-control custom-checkbox\">");t.b("\n" + i);t.b("		<input name=\"checkbox\" type=\"checkbox\" value=\"");t.b(t.v(t.f("value",c,p,0)));t.b("\" id=\"");t.b(t.v(t.f("uid",c,p,0)));t.b("\" class=\"custom-control-input\">");t.b("\n" + i);t.b("		<span class=\"custom-control-indicator\"></span>");t.b("\n" + i);t.b("		<span class=\"custom-control-description\">");t.b("\n" + i);t.b("			<label for=\"");t.b(t.v(t.f("uid",c,p,0)));t.b("\">");t.b(t.v(t.f("label",c,p,0)));t.b("</label>");t.b("\n" + i);t.b("		</span>");t.b("\n" + i);t.b("	</label>");t.b("\n" + i);t.b("</div>");t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<div class=\"sma-select-multi-item\">\n\t<label class=\"custom-control custom-checkbox\">\n\t\t<input name=\"checkbox\" type=\"checkbox\" value=\"{{value}}\" id=\"{{uid}}\" class=\"custom-control-input\">\n\t\t<span class=\"custom-control-indicator\"></span>\n\t\t<span class=\"custom-control-description\">\n\t\t\t<label for=\"{{uid}}\">{{label}}</label>\n\t\t</span>\n\t</label>\n</div>\n", H);return T.render.apply(T, arguments); };

/***/ }),

/***/ 856:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[2432]);


// WEBPACK FOOTER //
// sma.common-06f34aa5ef530712b08c.js